import React from 'react';
import { useStore } from '../store';
import { useShallow } from 'zustand/react/shallow';
import { Alert, AlertDescription } from '@roger/ui-components';
import { AlertTriangle } from 'lucide-react';
import {
  AgencyManagementSection,
  TestPatientCleanupSection,
} from '../components/admin';

const InternalAdmin: React.FC = () => {
  const { hasPermission } = useStore(
    useShallow(state => ({
      hasPermission: state.hasPermission,
    }))
  );

  // Permission check
  if (!hasPermission('emr:manage')) {
    return (
      <div className='container mx-auto px-4 py-6'>
        <Alert className='border-red-200 bg-red-50'>
          <AlertDescription className='text-red-800 flex gap-2 items-center'>
            <AlertTriangle className='h-4 w-4 text-red-600' />
            You don't have permission to access Internal Admin features. Please
            contact your administrator if you need access.
          </AlertDescription>
        </Alert>
      </div>
    );
  }

  return (
    <div className='space-y-6'>
      <div>
        <h1 className='text-3xl font-bold'>Internal Admin</h1>
        <p className='text-muted-foreground'>
          Roger internal administrative functions.
        </p>
      </div>

      <div className='grid gap-6'>
        {/* Agency Management Section - Editable */}
        <AgencyManagementSection mode='editable' />
        <TestPatientCleanupSection />
      </div>
    </div>
  );
};

export default InternalAdmin;
